import { render, staticRenderFns } from "./many.vue?vue&type=template&id=2e7c0562&scoped=true&"
import script from "./many.vue?vue&type=script&lang=js&"
export * from "./many.vue?vue&type=script&lang=js&"
import style0 from "./many.vue?vue&type=style&index=0&id=2e7c0562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c0562",
  null
  
)

export default component.exports